<div class="back">
  <h2>Upgrade to apply Pro optimization</h2>
</div>

<p class="db-desc mt5 mb30">Pro optimization level is available with all Pro plans<br/> of 10Web Booster.</p>

<div class="pro-features {{mode}}">
  <div class="pro-feature" *ngFor="let point of points">
    <img class="mr12" src="{{point.img}}" alt="">
    <div class="feature-content">
      <p><b [innerHTML]="point.title"></b></p>
      <p [innerHTML]="point.desc"></p>
    </div>
  </div>
</div>

<div class="text-center mb30 mt30">
  <button class="ds-btn-green ds-btn-xl rectangle" (click)="onStepChange.emit('plans'); sendEvent()">
    <span>{{'upgrade' | lowerCaseSpecificWords}}</span>
  </button>
</div>
